<template>
  <div id='art'>
    <div id='nav' class='container'>
      <div>
        <span v-for='(j, i) in journeys'>
          <router-link :class='j === journey ? "red" : ""'
            :to="{name: 'Art', params: {journey: j, index: 3}}">
            {{ j }}</router-link><span v-if='i < journeys.length - 1'> • </span>
        </span>
      </div>
      <div id='replay' @click='replay += 1'>replay</div>
    </div>

    <!-- if desktop, show all 7 days -->
    <div v-if='!isMobile' id='week' class='container'>
      <Day v-for='(texts, i) in days' :key='texts[0].day'
        v-bind='{
          headerHeight, footerHeight, isMobile, texts,
          flowerSizeScale, leafSizeScale, numPetalScale,
          journey, index: i, featuredIndex: +index, replay,
        }' />
    </div>
    <!-- else show only the day of the index (once it's loaded) -->
    <div v-else-if='days.length' id='week' class='container'>
      <Day v-bind='{
          headerHeight, footerHeight, isMobile,
          flowerSizeScale, leafSizeScale, numPetalScale,
          journey,  texts: days[index],
          index: +index, featuredIndex: +index, replay,
        }' />
    </div>
    <Legend />
  </div>
</template>

<script>
import * as d3 from 'd3';
import _ from 'lodash';
import {TimelineLite} from 'gsap';
import isMobile from 'ismobilejs';

import Day from './Day';
import Legend from './Legend';

const timezoneOffset = new Date().getTimezoneOffset() / 60;

export default {
  props: ['journey', 'index', 'headerHeight', 'footerHeight'],
  name: 'Art',
  components: {Day, Legend},
  data() {
    return {
      journeys: ['love', 'happiness', 'smiles', 'sunshine', 'moons'],
      isMobile: isMobile.phone || window.innerWidth < 480,
      days: [],
      allTexts: {},
      replay: 0,
      // scales
      flowerSizeScale: d3.scaleLinear().range([15, 30]),
      leafSizeScale: d3.scaleLinear().range([25, 45]),
      numPetalScale: d3.scaleQuantize().range(_.range(5, 9)),
    }
  },
  watch: {
    journey: function() {
      this.getJourney();
    },
  },
  methods: {
    getJourney: function() {
      const texts = this.allTexts[this.journey];
      if (texts) {
        // if it's already been loaded, recalculate positions
        this.setupScales(_.flatten(texts));
        this.days = texts;
        return;
      }
      d3.json(`./static/${this.journey}.json`, texts => {
        _.each(texts, d => {
          d.date = this.offsetByPST(new Date(+d.timestamp * 1000));
          d.formattedDate = d3.timeFormat('%A')(d.date);
        });
        this.setupScales(texts);
        this.days = this.allTexts[this.journey] = _.chain(texts)
          .groupBy(d => d3.timeDay.floor(d.date))
          .sortBy(texts => texts[0].date)
          .map(texts => {
            let prevText = null;
            _.each(texts, text => {
              // remember previous and next text
              if (prevText) prevText.nextText = text;
              text.prevText = prevText;
              prevText = text;
            });
            return texts;
          }).value();
      });
    },
    setupScales: function(texts) {
      const flowerExtent = d3.extent(_.filter(texts, d => d.sentiment > 0), d => d.keyword.length);
      const leafExtent = d3.extent(_.filter(texts, d => d.sentiment <= 0), d => d.keyword.length);
      this.flowerSizeScale.domain(flowerExtent);
      this.leafSizeScale.domain(leafExtent);
      const petalsExtent = d3.extent(_.filter(texts, d => d.sentiment > 0), d => d.entropy);
      this.numPetalScale.domain(petalsExtent);
    },
    offsetByPST: function(date) {
      return d3.timeHour.offset(date, timezoneOffset)
    },
  },
  mounted() {
    this.getJourney();
  },
}
</script>

<style scoped>
#art {
  position: relative;
  padding: 20px 30px;
}

#nav {
  margin-bottom: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
}

#nav a {
  margin: 0px;
  display: inline-block;
  font-size: 1.1em;
}

#nav .red {
  font-weight: bold;
}

#nav #replay {
  text-align: right;
  text-decoration: underline;
  cursor: pointer;
  font-size: 1.1em;
}

#week {
  position: relative;
  width: 100%;
  height: 700px;
}

#week.container {
  display: grid;
  grid-template-columns: 500px repeat(3, 1fr);
  grid-template-rows: auto auto;
  grid-gap: 10px;
  justify-content: center;
}

@media (min-width: 320px) and (max-width: 480px) {
  #art {
    padding: 10px;
  }

  #week.container {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-gap: 10px;
    justify-content: center;
  }

  #nav {
    grid-template-columns: auto;
    grid-template-rows: auto auto;
    text-align: center;
    grid-gap: 5px;
  }

  #nav #replay {
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Art.vue